.root * {
  visibility: hidden;
}

.animation {
  background-image: linear-gradient(
    to right,
    var(--color__gray-200) 33%,
    var(--color__gray-50),
    var(--color__gray-200) 66%
  );
  background-size: 300%;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
